import store2 from "store2";

export const QUERY_CACHE_STORAGE_KEY = "REACT_QUERY_OFFLINE_CACHE";

const SESSION_TOKEN_STORAGE_KEYS = ["auth", "finance_auth"];

type StoredTokens = {
    expires_at?: number;
};

export const clearStoredSession = () => {
    [...SESSION_TOKEN_STORAGE_KEYS, QUERY_CACHE_STORAGE_KEY].forEach((storageKey) => store2.remove(storageKey));
};

export const endSession = (destinationPath: string) => {
    clearStoredSession();
    window.location.replace(destinationPath);
};

export const sendTabToLogin = () => {
    window.location.replace("/login");
};

export const hasSessionExpired = (tokens: StoredTokens, now: number) => {
    const hasExpired = !tokens.expires_at || tokens.expires_at <= now;
    return hasExpired;
};

export const isSessionClearedEvent = (storageEvent: StorageEvent) => {
    const isWholeStorageCleared = storageEvent.key === null;
    const isSessionKeyRemoved = SESSION_TOKEN_STORAGE_KEYS.includes(storageEvent.key ?? "") && !storageEvent.newValue;
    const isSessionCleared = isWholeStorageCleared || isSessionKeyRemoved;
    return isSessionCleared;
};
